__turbopack_context__.v({
  "btnPadrao": "Ll8Y4q_btnPadrao",
  "containerRecursos": "Ll8Y4q_containerRecursos",
  "conteudoComImagem": "Ll8Y4q_conteudoComImagem",
  "dFlex": "Ll8Y4q_dFlex",
  "nossosRecursos": "Ll8Y4q_nossosRecursos",
  "plataformaInteligente": "Ll8Y4q_plataformaInteligente",
  "subtitle": "Ll8Y4q_subtitle",
  "textoAba": "Ll8Y4q_textoAba",
  "title": "Ll8Y4q_title",
  "uiContainer": "Ll8Y4q_uiContainer",
});
